import React from "react";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = !!localStorage.getItem("adminToken"); // check token

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} /> // show component if logged in
        ) : (
          <Redirect to="/auth/signin-customer" /> // redirect if not
        )
      }
    />
  );
};

export default PrivateRoute;
